import React from 'react'
import style from "./ButtonClose.module.scss";

export default function ButtonClose( {className, setActiveCategory}) {
    return (
        <>
            <div onClick={() => setActiveCategory(null)} className={`${style.close} ${className}`}>
                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80"
                     fill="none">
                    <rect width="80" height="80" rx="40" fill="#FF8686" fillOpacity="0.1"/>
                    <path d="M29 51.6274L51.6274 29" stroke="#D11018" strokeWidth="1.6"
                          strokeLinecap="round"/>
                    <path d="M29.0005 29L51.6279 51.6274" stroke="#D11018" strokeWidth="1.6"
                          strokeLinecap="round"/>
                </svg>
            </div>
        </>
    )
}
